<template>
  <div class="app-container">
    <form-table
      ref="baseForm"
      :queryOptions="searchFormData"
      :tableOptions="tableOptions"
      :headerTitle="headerTitle"
      :queryUrl="queryUrl"
      :btnData="btnData"
      @clickBtn="onSelect"
      :query-permission="['system:notice:query']"
    >
    </form-table>
  </div>
</template>

<script>
import { dataCenter } from '@/utils/dataCenter'
import { getDicts } from '@/api/dict/data'
export default {
  name: 'otherConsultation',
  dicts: ['sys_depart_attribute'],
  data() {
    return {
      btnData: [{ text: '下载' }],
      headerTitle: '其他资讯',
      searchFormData: [
        { props: 'fileName', label: '文件名', type: 'input' },
        {
          props: 'year',
          label: '年份',
          width: '120px',
          type: 'date',
          valueFormat: 'yyyy',
          dateFormat: 'yyyy',
          dateType: 'year'
        },
        {
          props: 'department',
          label: '部门属性',
          type: 'DictSelect',
          dictCode: 'sys_depart_attribute',
          multiple: false
        }
      ],
      tableOptions: [
        {
          prop: 'fileName',
          label: '文件名',

          type: 'fileName',
          rightTop: {
            left: {
              prop: 'year',
              label: '年份'
            }
          }
          // rightBottom: { prop: 'departLabel', label: '部门属性'}
        },

        // {
        //   prop: 'year',
        //   label: '年份'
        // },
        {
          prop: 'departLabel',
          label: '部门属性'
        },
        {
          prop: 'createdDate',
          label: '上传时间'
        }
      ],
      queryUrl: '/bff-dp-mobile/other-document/dealer/list'
    }
  },
  created() {
    // this.setOptions()
  },
  methods: {
    async setOptions() {
      const options = await getDicts('sys_depart_attribute').then(res => {
        let list = []
        if (res.code === 200 && res.data.length > 0) {
          list = res.data
        }
        return list
      })
      this.tableOptions[0].rightBottom.options = options
    },
    onSelect(text, queryParams, list) {
      console.log(text, queryParams)
      this.daowload(list)
    },
    daowload(list) {
      dataCenter.downloadFile(list)
    }
  }
}
</script>
